import { render, staticRenderFns } from "./WarehouseStockManagementDetail.vue?vue&type=template&id=2950c6c6&"
import script from "./WarehouseStockManagementDetail.vue?vue&type=script&lang=js&"
export * from "./WarehouseStockManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseStockManagementDetail.vue?vue&type=style&index=0&id=2950c6c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports